module.exports = __webpack_public_path__ + "static/q6-0454f54948b0d44642219f3480a6b6cb.png";